import { Box, BoxProps, Button, Collapse, HStack } from '@chakra-ui/react'
import { useRef, useState } from 'react'

import { ChevronIcon } from '../../components/Icons/ChevronIcon'
import { useRowWrapDetector } from '../../hooks/useRowWrapDetector'
import { colors } from '../../theme/colors'
import { createWidget } from '../widget-utils'

export const ExpandableCardWidget = ({ children, ...props }: BoxProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const { isWrapping, firstRowHeight, containerPadding } =
    useRowWrapDetector(ref)

  const totalSummaryValues = Array.from(ref.current?.children || []).length
  return (
    <HStack
      rounded="lg"
      shadow="card.default"
      spacing="0"
      alignItems="stretch"
      {...props}
    >
      <Box>
        <Button
          onClick={() => setIsOpen(!isOpen)}
          display={isWrapping ? 'block' : 'none'}
          h="full"
          bgColor="presets.turquoise.60"
          color="presets.neutral.0"
          roundedRight="none"
          _hover={{
            backgroundColor: 'presets.turquoise.70',
          }}
        >
          <ChevronIcon
            width="10px"
            height="5px"
            transform={`rotate(${isOpen ? '180deg' : '0deg'})`}
          />
        </Button>
      </Box>
      <Collapse
        style={{
          backgroundColor: colors.body.bg,
          width: '100%',
        }}
        in={isOpen}
        startingHeight={firstRowHeight + containerPadding}
      >
        <HStack
          p="30px"
          justifyContent={
            isWrapping
              ? 'none'
              : totalSummaryValues < 5
                ? 'flex-start'
                : 'space-between'
          }
          spacing={totalSummaryValues < 5 ? '64px' : '30px'}
          flexWrap="wrap"
          ref={ref}
        >
          {children}
        </HStack>
      </Collapse>
    </HStack>
  )
}

export const ExpandableCardWidgetDefinition = createWidget(
  ExpandableCardWidget,
  {
    type: 'ExpandableCard',
  },
)
